import { render } from "./Number.component.vue?vue&type=template&id=3de9c6b2&scoped=true"
import script from "./Number.component.vue?vue&type=script&lang=js"
export * from "./Number.component.vue?vue&type=script&lang=js"

import "./Number.component.vue?vue&type=style&index=0&id=3de9c6b2&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3de9c6b2"]])

export default __exports__
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QRating from 'quasar/src/components/rating/QRating.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QInput from 'quasar/src/components/input/QInput.js';
import qInstall from "../../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QItem,QItemSection,QItemLabel,QRating,QBtn,QIcon,QInput});
